import { createReducer, on } from '@ngrx/store';
import * as fromAuthActions from '../actions/auth.actions';
import * as fromAccountActions from '../actions/account.actions';
import * as fromRideAction from '../actions/ride.action';
import { UserProfile } from 'src/app/models/user-profile.model';

export const featureKey = 'account';

export interface State {
  user: UserProfile;
  contacts: {
    data: Array<any>,
    isLoaded: Boolean
  },
  transactions: {
    data: Array<any>,
    isLoaded: Boolean
  };
}

export const initialState: State = {
  user: null,
  transactions: {
    data: [],
    isLoaded: false
  },
  contacts: {
    data: [],
    isLoaded: false
  }
};

export const reducer = createReducer(
  initialState,  
  on(fromAccountActions.updateUserProfileSuccess, (state: State, props: any) => ({
    ...state,
    user: props.data
  })),
  on(fromAccountActions.getTransactionSuccess, (state: State, props: any) => ({
    ...state,
    transactions: { data: props.data, isLoaded: true },
  })),
  on(fromAccountActions.getUserContactSuccess, (state: State, props: any) => ({
    ...state,
    contacts: { data: props.data, isLoaded: true },
  })),
  on(fromAuthActions.autoLogout, (state: State, props) => initialState)
);
